var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from 'react';
import { v4 as uuid } from 'uuid';
import Typography from '../../GSAPAnimations/Typography';
import { Linear } from 'gsap';
import './Hero.scss';
import { sampleData } from './data';
import { gsapTimelineFromTo } from '../../GSAPAnimations/Animation/helper';
export var ArticleHero = function (props) {
    var time = '';
    var heading = useRef(null);
    var text = useRef(null);
    var headingConfigs = function (ref) { return ({
        config: {
            opacity: 0,
            // autoAlpha:0,
            //y: 100,
        },
        config2: {
            duration: 0.35,
            // autoAlpha:1,
            opacity: 1,
            y: 0,
            ease: Linear.easeIn,
            scrollTrigger: {
                trigger: document.getElementById(ref),
                start: 'top center',
                toggleActions: 'play none none reverse',
            },
        },
    }); };
    var subheadingConfigs = function (ref) { return ({
        config: {
            opacity: 0,
        },
        config2: {
            duration: 0.35,
            opacity: 1,
            y: 0,
            delay: 0.3,
            ease: Linear.easeIn,
            scrollTrigger: {
                trigger: document.getElementById(ref),
                start: 'top center',
                toggleActions: 'play none none reverse',
            },
        },
    }); };
    return (_jsxs("div", __assign({ className: "article-hero y snap-center", style: { backgroundColor: sampleData.mockArticleHero.color } }, { children: [_jsx("div", { className: "article-hero__mask" }, void 0),
            _jsxs("div", __assign({ className: "article-hero__header" }, { children: [_jsx(Typography, { title: sampleData.mockArticleHero.title, variant: "h1", classes: 'article-hero__header-1', id: uuid(), reference: heading, animate: gsapTimelineFromTo, configs: headingConfigs("heading--" + uuid()) }, void 0),
                    _jsx(Typography, { title: props.time + ' MIN. READ', variant: "p", classes: 'subheader', id: uuid(), reference: text, animate: gsapTimelineFromTo, configs: subheadingConfigs("body--" + uuid()) }, void 0)] }), void 0)] }), void 0));
};
